<ng-container>
	<div class="container" fxLayout="column" fxLayoutAlign="center center">
		<div class="title">{{message}}</div>
		<button (click)="send()" color="warn" mat-raised-button style="width:fit-content">ping!</button>
	</div>
</ng-container>
